import { User } from '@shared/welibrary-graphql/types';
import { USER_TYPE_EPHEMERAL } from '@core/utilities/constants/user';

// eslint-disable-next-line import/prefer-default-export
export function isEphemeralUser(currentUser: User) {
    return currentUser && currentUser.type === USER_TYPE_EPHEMERAL;
}
